// extracted by mini-css-extract-plugin
export var defaultWrapper = "_l4-3";
export var downloadButton = "_l4-4";
export var fileContainer = "_l4-9 _l4-7";
export var fileContainerBase = "_l4-7";
export var fileContainerBaseSm = "_l4-a _l4-7";
export var fileContainerFixedHeight = "_l4-8 _l4-7";
export var fileContainerFixedHeightSm = "_l4-c _l4-a _l4-7";
export var fileContainerSm = "_l4-b _l4-a _l4-7";
export var fileInfo = "_l4-5";
export var fileInfoWidthRestricted = "_l4-6";
export var fileType = "_l4-1";
export var fileTypeName = "_l4-2";
export var fileTypeSm = "_l4-d _l4-1";
export var image = "_l4-0";
export var link = "_l4-f";
export var overflowEllipsis = "_l4-e";